export default "__VITE_PUBLIC_ASSET__e65bed7c__"